import { registerFeatureI18n } from '@saas-kit/lib';

import en from './i18n/en/home.json';
import ar from './i18n/ar/home.json';

registerFeatureI18n('adminHome', { en, ar });

export { AdminHomePage } from './AdminHomePage';
